import { reportForms } from '@/constants/reports';
import last from 'lodash/last';

import { formatDateParams, formatFundDate } from '../libs/time';
import { settingsGKZParams } from '../libs/formats/gkzParams';

/*
    Модель для Базового фильтра.
*/

export const baseFilterReportModel = {
    name: 'baseFilterReport',
    state: {
        /*
            Форма, соответствующая выбранному типу отчета. По умолчанию определена как БАЗОВАЯ.
        */
        reportTypeForm: reportForms.BASE_GROUPING,
        /*
            Значения формы.
            Формы динамические, поэтому в этом поле может быть разный набор полей.
         */
        params: {},
        /*
            Флаг, который отвечает за возможность взаимодействия с деревом.
            Если false - взаимодействия отключены
            Если true - взаимодействия включены
        */
        withTree: false,
    },
    reducers: {
        setParams(state, payload) {
            return { ...state, params: payload };
        },
        setTreeInteraction(state, payload) {
            return { ...state, withTree: payload };
        },
        setMerInteraction(state, payload) {
            return { ...state, withTree: payload };
        },
        setReportTypeForm(state, payload) {
            const selectedTypeForm = payload || reportForms.BASE;
            return { ...state, reportTypeForm: selectedTypeForm };
        },
    },
    effects: dispatch => ({
        getFilterParams(reportTypePath, rootState) {
            const { params, reportTypeForm } = rootState.baseFilterReport;

            return formatFilterParams(reportTypePath, reportTypeForm, params);
        },
    }),
};

/*
    Добавляет к пути суффикс _ByElements, если выполнено условие.
*/
function addSuffix(params, path) {
    if ('isElements' in params && params.isElements) return `${path}_ByElements`;
    return path;
}

/*
    TODO: При появлении других сложных отчетов надо переписать этот метод более удобно.
*/
function formatFilterParams(reportTypePath, reportForm, params) {
    const typeWithSuffix = addSuffix(params, reportTypePath);

    const result = {
        reportType: typeWithSuffix,
    };

    switch (reportForm) {
        case reportForms.EMPTY:
            break;
        case reportForms.SAMPLING_GKZ: {
            Object.assign(result, settingsGKZParams(params));
            break;
        }
        case reportForms.COMPLETENESS: {
            const dateParams = formatDateParams(params.period, params.date);

            Object.assign(result, dateParams, { Selected_Criterion_IDs: params.criteria.join(',') });
            break;
        }
        case reportForms.SHORT_BASE_GROUPING:
        case reportForms.SHORT_BASE: {
            const dateParams = formatFundDate(params.month, params.year);

            Object.assign(result, dateParams);
            break;
        }
        default:
            {
                const dateParams = formatDateParams(params.period, params.date);
                Object.assign(result, dateParams);
            }
            break;
    }

    return result;
}
